import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MobileService } from '@lms-approval/shared/micro-frontend';
import { IPageSafeSpace } from '@adnoc/servicebox';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private mobileService: MobileService) {}

  // TODO Fix code below
  get isMobile(): boolean {
    return false;
    // return this.mobileService.isInsideApp();
  }

  get mobileSafeSpace(): IPageSafeSpace {
    return this.mobileService.getSafeSpace();
  }

  getDrawerSettings(): MatDialogConfig {
    const isMobile = this.isMobile;

    return isMobile ? this.getMobileDrawerSettings() : this.getDesktopDrawerSettings();
  }

  getFullscreenSettings(): MatDialogConfig {
    const bottomOffset = 8;
    let topOffset = 8;

    if (this.isMobile) {
      topOffset += this.mobileSafeSpace.top;
    }

    const verticalMargin = topOffset + bottomOffset;

    return {
      height: `calc(100vh - ${verticalMargin}px)`,
      maxHeight: `calc(100vh - ${verticalMargin}px)`,
      width: 'calc(100vw - 16px)',
      maxWidth: 'calc(100vw - 16px)',
      position: { right: '8px', top: `${topOffset}px` },
    };
  }

  private getMobileDrawerSettings(): MatDialogConfig {
    const baseTopMobileOffset = 10;
    const finalTopMobileOffset = baseTopMobileOffset + this.mobileSafeSpace.top;

    return {
      height: `calc(100vh - ${finalTopMobileOffset}px)`,
      width: '100%',
      maxWidth: '712px',
      panelClass: ['servicebox-bottom-sheet', 'module-mobile-view'],
      position: { top: `${finalTopMobileOffset}px` },
    };
  }

  private getDesktopDrawerSettings(): MatDialogConfig {
    return {
      height: 'calc(100vh - 16px)',
      width: '560px',
      maxWidth: 'calc(100vw - 16px)',
      panelClass: ['servicebox-drawer', 'module-desktop-view'],
      position: { right: '8px' },
    };
  }
}
